<template>
  <div>
    <arrival-table
      v-if="info.shorthand_type === 'arrivals'"
      class="text-center text-white text-uppercase w-100"
      :flights="info.flights"
      :last-update="info.last_update"
    />
    <departure-table
      v-else
      class="text-center text-white text-uppercase w-100"
      :flights="info.flights"
      :last-update="info.last_update"
    />
    <div class="row">
      <div
        v-for="(city, index) in info.extra"
        :key="'city_' + index"
        class="col d-flex flex-column align-items-center"
      >
        <p class="m-0 h1 text-secondary">
          {{ city.city }}
        </p>
        <p class="m-0 h1 mb-3">
          {{ city.temperature }}&#176;F
        </p>
        <i
          class="wi"
          style="font-size: 100px"
          :class="city.icon_class"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArrivalTable from './arrival-table.vue';
import DepartureTable from './departure-table.vue';

export default {
  name: 'Airline',
  components: {
    ArrivalTable,
    DepartureTable,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
};
</script>
